import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=3c1ef684"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VForm,VRow,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("/Users/afonsomonteiro/onboarding/onboarding/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1ef684')) {
      api.createRecord('3c1ef684', component.options)
    } else {
      api.reload('3c1ef684', component.options)
    }
    module.hot.accept("./Order.vue?vue&type=template&id=3c1ef684", function () {
      api.rerender('3c1ef684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Order.vue"
export default component.exports